import { EntityType, useGetTasksByEntityWithParentQuery } from '@exam-management/graphql';
import { ErrorBox, Loading } from '@shared/components';
import type { PropsWithChildren } from '@shared/utils';
import { createContext, useMemo } from 'react';
import { Outlet } from 'react-router-dom';

import type { QSetReviewHistoryContextData } from './types';

interface QSetReviewHistoryProviderProps extends PropsWithChildren {
  qSetId: string;
}

export const QSetReviewHistoryContext = createContext<QSetReviewHistoryContextData | undefined>(
  undefined,
);

export default function QSetReviewHistoryProvider(props: Readonly<QSetReviewHistoryProviderProps>) {
  const { qSetId, children } = props;

  const {
    data,
    loading: isLoading,
    error,
  } = useGetTasksByEntityWithParentQuery({
    variables: {
      getTasksByEntityWithParentInput: {
        entityId: qSetId,
        entityType: EntityType.Qset,
      },
    },
  });

  const contextValue = useMemo(() => {
    return {
      taskDetails: data?.wflGetTasksByEntityWithParent.tasks ?? [],
    };
  }, [data]);

  if (isLoading) {
    return <Loading height='100%' />;
  }

  if (error) {
    return <ErrorBox height='100%' />;
  }

  return (
    <QSetReviewHistoryContext.Provider value={contextValue}>
      {children ?? <Outlet />}
    </QSetReviewHistoryContext.Provider>
  );
}
